import { Flag } from '../interfaces/Flag';

export const INITIAL_VALUES: Flag = {
  flag: ''
}
